import React, { useEffect, useState } from 'react';
import { PDFViewer, Document, Page, View, Text, Image } from '@react-pdf/renderer';
import axios from 'axios';
import config from '../config';

const PdfReport = ({ groupedData, centerInfo, location, district }) => (

  <Document>
    {Object.entries(groupedData).map(([challanNo, { full_data, summary_data }], index) => (

      <Page size="A4" orientation="landscape" style={{ padding: 15, fontSize: 10, fontFamily: "Helvetica" }}>

        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <Image src="../assets/images/MBOSE.png" style={{ width: 40, height: 40, marginRight: 10 }} />
          <View style={{ flex: 1, textAlign: 'center' }}>
            <Text style={{ fontSize: 12, fontWeight: 'bold' }}>Meghalaya Board Of School Education ( SSLC )</Text>
            <Text style={{ marginTop: 4, fontSize: 10, fontWeight: 'bold' }}>List of Examinees Supplementary Examination, Online Applications for 2026</Text>
          </View>
        </View>

        <View style={{ flexDirection: "row", justifyContent: "space-between", paddingBottom: 10, marginBottom: 10 }}>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>Centre Code: </Text>
            <Text style={{ textDecoration: "underline" }}>{centerInfo.code}</Text>
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>Centre Name: </Text>
            <Text style={{ textDecoration: "underline" }}>{centerInfo.name}</Text>
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>District: </Text>
            <Text style={{ textDecoration: "underline" }}>{district}</Text>
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>Location: </Text>
            <Text style={{ textDecoration: "underline" }}>{location}</Text>
          </Text>
        </View>

        <View style={{ marginTop: 10, fontSize: 5 }}>
          <View style={{ flexDirection: 'row', backgroundColor: '#f0f0f0' }}>
            {["Sl No.", "Roll Number", "Reg. No", "Reg. Year", "Name of Applicant", "Father's Name", "Mother's Name", "DOB", "Caste", "Exam Type", "Gender", "Subject 1", "Subject 2", "Subject 3", "Subject 4", "Subject 5", "Subject 6"].map((header, index) => (
              <Text key={index} style={{ flex: 1, fontWeight: 'bold', textAlign: 'center', fontSize: 7, border: '1px solid black', padding: 2 }}>{header}</Text>
            ))}
          </View>
          {full_data.map((record, index) => (
            <View key={index} style={{ flexDirection: 'row' }}>
              {[index + 1, record.ROLL_NO, record.REGISTRATION_NO, record.REGISTRATION_YEAR, record.CAND_NAME, record.FATHERS_NAME, record.MOTHERS_NAME, record.DOB, record.CATEGORY_NAME, record.EXAM_TYPE === "Improvement" ? "I" : record.EXAM_TYPE === "Supplementary" ? "S" : record.EXAM_TYPE, record.GENDER_NAME, record.SUBJECT_1_NAME, record.SUBJECT_2_NAME, record.SUBJECT_3_NAME, record.SUBJECT_4_NAME, record.SUBJECT_5_NAME, record.SUBJECT_6_NAME].map((item, colIndex) => (
                <Text key={colIndex} style={{ flex: 1, textAlign: 'center', fontSize: 5, border: '1px solid black', padding: 2 }}>{item || '-'}</Text>
              ))}
            </View>
          ))}
        </View>
        <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 50, fontSize: 8 }}>
          <View>
            <Text>i) Exam Type: S = SUPPLEMENT I = IMPROVEMENT</Text>
            <Text>ii) Appearing in: ALL = All Subjects, IMP = Improvement</Text>
          </View>
          <View>
            <Text>Paid by Challan No: {challanNo}</Text>
            <Text>No of Candidate in the Challan: {summary_data.TOTAL}</Text>
          </View>
          <View style={{ marginRight: "50px" }}>
            <Text>Signature of Head of the Institution with Seal</Text>
          </View>
        </View>

        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: 10, marginTop: "50px" }}>
          <Image src="../assets/images/MBOSE.png" style={{ width: 40, height: 40, marginRight: 10 }} />
          <View style={{ flex: 1, textAlign: "center" }}>
            <Text style={{ fontSize: 12, fontWeight: "bold" }}>Meghalaya Board Of School Education</Text>
            <Text style={{ marginTop: 4, fontSize: 10 }}>
              <Text style={{ fontWeight: "bold" }}>List of Examinees Supplementary Examination, Online Applications for 2026</Text>
            </Text>
          </View>
        </View>

        <View style={{ flexDirection: "row", justifyContent: "space-between", paddingBottom: 10, marginBottom: 10 }}>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>Centre Code: </Text>
            <Text style={{ textDecoration: "underline" }}>{centerInfo.code}</Text>
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>Centre Name: </Text>
            <Text style={{ textDecoration: "underline" }}>{centerInfo.name}</Text>
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>District: </Text>
            <Text style={{ textDecoration: "underline" }}>{district}</Text>
          </Text>
          <Text style={{ fontSize: 10 }}>
            <Text style={{ fontWeight: "bold" }}>Location: </Text>
            <Text style={{ textDecoration: "underline" }}>{location}</Text>
          </Text>
        </View>

        {/* <View style={{ marginTop: 10, marginHorizontal: 280, fontSize: 7 }} wrap={false}>
       
          <View style={{ flexDirection: "row", backgroundColor: "#f0f0f0" }}>
            {["Gender", "Improvement", "Supplimentary", "Total"].map((header, index) => (
              <Text
                key={index}
                style={{
                  flex: 1,
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: 7,
                  border: "1px solid black",
                  padding: 2
                }}
              >
                {header}
              </Text>
            ))}
          </View>

          {summary_data.gender_summary.map((row, rowIndex) => (
            <View key={rowIndex} style={{ flexDirection: "row" }}>
              <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
                {row.GENDER}
              </Text>
              <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
                {row.IMPROVEMENT || "-"}
              </Text>
              <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
                {row.BETTERMENT || "-"}
              </Text>
              <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
                {(row.IMPROVEMENT || 0) + (row.BETTERMENT || 0)}
              </Text>
            </View>
          ))}

          <View style={{ flexDirection: "row" }}>
            <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2, fontWeight: "bold" }}>
              TOTAL
            </Text>
            <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
              {summary_data.IMPROVEMENT_TOTAL}
            </Text>
            <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
              {summary_data.BETTERMENT_TOTAL}
            </Text>
            <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
              {summary_data.TOTAL}
            </Text>
          </View>
        </View> */}
        <View style={{ marginTop: 10, marginHorizontal: 280, fontSize: 7 }} wrap={false}>

          <View style={{ flexDirection: "row", backgroundColor: "#f0f0f0" }}>
            {["Gender", "Supplimentary", "Total"].map((header, index) => (
              <Text
                key={index}
                style={{
                  flex: 1,
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: 7,
                  border: "1px solid black",
                  padding: 2
                }}
              >
                {header}
              </Text>
            ))}
          </View>

          {summary_data.gender_summary.map((row, rowIndex) => (
            <View key={rowIndex} style={{ flexDirection: "row" }}>
              <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
                {row.GENDER}
              </Text>
              <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
                {row.BETTERMENT || "-"}
              </Text>
              <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
                {row.BETTERMENT || 0}
              </Text>
            </View>
          ))}
          <View style={{ flexDirection: "row" }}>
            <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2, fontWeight: "bold" }}>
              TOTAL
            </Text>
            <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
              {summary_data.BETTERMENT_TOTAL}
            </Text>
            <Text style={{ flex: 1, textAlign: "center", fontSize: 7, border: "1px solid black", padding: 2 }}>
              {summary_data.BETTERMENT_TOTAL}
            </Text>
          </View>
        </View>

      </Page>
    ))}
  </Document>
);
const ConsolidatedList = () => {
  const [groupedData, setGroupedData] = useState({});
  const [centerInfo, setCenterInfo] = useState({ code: '', name: '' });
  const [location, SetLocation] = useState();
  const [district, SetDistrict] = useState();
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      const centerCode = localStorage.getItem('CentCode');
      const centerName = localStorage.getItem('schoolName');


      if (!token || !centerCode) {
        console.error('Missing token or centerCode in localStorage');
        return;
      }
      setCenterInfo({ code: centerCode, name: centerName });
      try {
        const response = await axios.post(
          `${config.API_BASE_URL}/auth/ListOfExaminees`,
          { CENT_CODE: centerCode },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        console.log('API Response:', response.data);
        setGroupedData(response.data.data.examinees_data);
        SetLocation(response.data.data.center_details.LOCATION);
        SetDistrict(response.data.data.center_details.DISTRICT);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <PDFViewer style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <PdfReport groupedData={groupedData} centerInfo={centerInfo} location={location} district={district} />
    </PDFViewer>
  );
};

export default ConsolidatedList;



